module.exports = __webpack_public_path__ + "static/img/GeoColouredLens_logo.ec5bd24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/GeoColouredLens_logo.png
// module id = bypJ
// module chunks = 0